export default {"src":"/_next/static/media/skipping.mono.0dadfde6.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};